import React from 'react';
import SkillPill from '../../Utils/SkillPill';

const HardSkills = ({ hardSkills }) => {
  return (
    <div className="bg-white rounded-lg shadow" style={{ overflow: 'visible', borderRadius: '0.5rem' }}>
      <div className="px-6 py-4">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Hard Skills</h3>
        {hardSkills?.items ? (
          Array.isArray(hardSkills.items) ? (
            <div className="flex flex-wrap gap-4">
              {[...hardSkills.items]
                .sort((a, b) => {
                  // First, check if either skill is in the top 5
                  const aIsTop5 = a.top5 === true;
                  const bIsTop5 = b.top5 === true;
                  
                  // If one is top 5 and the other isn't, the top 5 comes first
                  if (aIsTop5 && !bIsTop5) return -1;
                  if (!aIsTop5 && bIsTop5) return 1;
                  
                  // If both are top 5 or neither is top 5, sort by seniority
                  // Define seniority order: Senior > Middle > Junior
                  const seniorityOrder = { 'senior': 3, 'middle': 2, 'junior': 1 };
                  // Get seniority level or default to 0 if not found
                  // Convert to lowercase for case-insensitive comparison
                  const aGrade = a.estimatedgrade ? a.estimatedgrade.toLowerCase() : '';
                  const bGrade = b.estimatedgrade ? b.estimatedgrade.toLowerCase() : '';
                  const aOrder = seniorityOrder[aGrade] || 0;
                  const bOrder = seniorityOrder[bGrade] || 0;
                  // Sort in descending order (Senior first)
                  return bOrder - aOrder;
                })
                .map((skill, index) => (
                <SkillPill
                  key={index}
                  name={skill.skill}
                  seniority={skill.estimatedgrade}
                  yearsExperience={skill.yearsExperience}
                  title={skill.rationale || "No rationale provided"}
                  isTop5={skill.top5 === true}
                  gradeSource={skill.gradesource}
                  numberOfMentions={skill.numberOfMentions}
                  inferredYearsExperience={skill.inferredYearsExperience}
                  context={skill.context}
                />
              ))}
            </div>
          ) : (
            <div>
              <SkillPill
                name={hardSkills.items.skill}
                seniority={hardSkills.items.estimatedgrade}
                yearsExperience={hardSkills.items.yearsExperience}
                title={hardSkills.items.rationale || "No rationale provided"}
                isTop5={hardSkills.items.top5 === true}
                gradeSource={hardSkills.items.gradesource}
                numberOfMentions={hardSkills.items.numberOfMentions}
                inferredYearsExperience={hardSkills.items.inferredYearsExperience}
                context={hardSkills.items.context}
              />
            </div>
          )
        ) : (
          <p className="text-gray-500 italic">No hard skills listed</p>
        )}
      </div>
    </div>
  );
};

export default HardSkills;
